export default function WhatIsCorporateAcademy() {
  const differences = [
    { icon: 'ri-flashlight-line', title: 'Отдельные тренинги', desc: 'Дают краткосрочный эффект. Через 2 недели 70% информации забывается. Нет системы закрепления.' },
    { icon: 'ri-computer-line', title: 'Курсы и вебинары', desc: 'Хороши как инструмент, но без привязки к компетенциям и бизнес-целям — просто контент.' },
    { icon: 'ri-calendar-check-line', title: 'Разовое обучение', desc: 'Решает одну задачу здесь и сейчас. Не создаёт культуру постоянного развития.' },
    { icon: 'ri-building-2-line', title: 'Корпоративная академия', desc: 'Система: компетенции → обучение → практика → оценка → развитие. Работает постоянно.' },
  ];

  const steps = [
    { icon: 'ri-building-4-line', label: 'Компания', desc: 'Определяет стратегические цели и необходимые компетенции' },
    { icon: 'ri-organization-chart', label: 'Корпоративная академия', desc: 'Создаёт систему обучения под бизнес-задачи' },
    { icon: 'ri-award-line', label: 'Компетенции', desc: 'Сотрудники развивают нужные навыки и знания' },
    { icon: 'ri-user-heart-line', label: 'Поведение', desc: 'Меняются подходы к работе и взаимодействию' },
    { icon: 'ri-line-chart-line', label: 'Бизнес-результат', desc: 'Рост продаж, снижение текучести, масштабирование' },
  ];

  return (
    <section id="what-is" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Что такое корпоративная академия
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Корпоративная академия — это не учебный центр и не набор курсов. Это <strong>система развития сотрудников</strong>, которая связывает обучение с бизнес-результатами компании.
        </p>

        {/* Differences */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-16">
          {differences.map((d, i) => (
            <div key={i} className={`rounded-xl p-6 border ${i === 3 ? 'bg-teal-50 border-teal-300 ring-2 ring-teal-200' : 'bg-gray-50 border-gray-200'}`}>
              <div className={`w-11 h-11 rounded-lg flex items-center justify-center mb-4 ${i === 3 ? 'bg-teal-600' : 'bg-gray-200'}`}>
                <i className={`${d.icon} text-lg ${i === 3 ? 'text-white' : 'text-gray-600'}`}></i>
              </div>
              <h3 className={`font-bold mb-2 text-sm ${i === 3 ? 'text-teal-800' : 'text-gray-900'}`}>{d.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{d.desc}</p>
            </div>
          ))}
        </div>

        {/* Scheme */}
        <div className="max-w-4xl mx-auto bg-gray-50 rounded-2xl p-8 md:p-12 border border-gray-200">
          <h3 className="text-xl font-bold text-gray-900 text-center mb-2">Как корпоративная академия создаёт бизнес-результат</h3>
          <p className="text-gray-600 text-center mb-10 text-sm">Системная цепочка от стратегии компании до измеримых показателей</p>

          <div className="relative">
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 bg-teal-200 rounded-full transform -translate-x-1/2"></div>
            <div className="space-y-6">
              {steps.map((step, i) => (
                <div key={i} className={`relative flex items-center gap-6 ${i % 2 === 1 ? 'md:flex-row-reverse' : ''}`}>
                  <div className="hidden md:flex w-1/2"></div>
                  <div className="relative z-10 w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 ring-4 ring-white">
                    <i className={`${step.icon} text-lg text-white`}></i>
                  </div>
                  <div className="flex-1 bg-white rounded-xl p-5 border border-gray-200 shadow-sm">
                    <h4 className="font-bold text-gray-900 text-sm mb-1">{step.label}</h4>
                    <p className="text-gray-600 text-xs leading-relaxed">{step.desc}</p>
                  </div>
                  <div className="hidden md:flex w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}